<template>
<div id="app">
    <v-app>
        <v-app-bar app clipped-left color="indigo" dark>

          <v-toolbar-title>
            <v-btn text to="/" id="no-background-hover">
              TestVirtual
            </v-btn>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <span v-if="user">{{user['username']}}</span>

          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item>
              <v-btn @click.prevent="logout" text>
                <v-icon>
                  mdi-exit-to-app
                </v-icon>
                Salir
              </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>

        </v-app-bar>
        <v-navigation-drawer 
            app
            permanent
            clipped
            hide-overlay
        >
            <v-list-item class="px-2">
                <v-list-item-avatar>
                    <v-icon>mdi-account-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="text-truncate">
                  {{rol}}
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list rounded>
                <v-list-item v-for="item in items" :key="item.title" link :to="item.href">
                    <v-list-item-icon>
                        <v-icon color="indigo">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="indigo--text">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-main app>
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="text-center">
                  <router-view></router-view>
              </v-col>
            </v-row>
          </v-container>
        </v-main>
    </v-app>
</div>
</template>

<script>

export default {
   data () {
      return {
        normalItems: [
          { title: 'Pruebas', icon: 'mdi-format-list-bulleted', href: '/pruebas/'},
          { title: 'Imágenes', icon: 'mdi-image', href: '/imagenes/'},
        ],
        adminItems: [
          { title: 'Pruebas', icon: 'mdi-format-list-bulleted', href: '/pruebas/'},
          { title: 'Imágenes', icon: 'mdi-image', href: '/imagenes/'},
          { title: 'Administración', icon: 'mdi-hammer-screwdriver', href: '/admin/'},
        ],
        sidebarMenu: true,
      }
    },

  computed: {
    user() {
      return this.$store.state.user;
    },
    rol() {
      if (this.user.groups.length > 0) {
        return this.$store.state.roles.find(obj => obj.id === this.user.groups[0]).name;
      }
      return "";
    },
    items() {
      if (this.user.groups.includes(1)) {
        return this.adminItems;
      }
      return this.normalItems;
    }
  },

  methods: {
    logout() {
      this.$store.commit('removeToken');
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
#no-background-hover::before {
   background-color: transparent !important;
}
</style>
